const roles = {
    user: 'user',
    parentUser: 'parent-user',

    admin: 'admin',
    parentAdmin: 'parent-admin',

    owner: 'owner',
    parentOwner: 'parent-owner',

    callCenter: 'callcenter',
    parentCallCenter: 'parent-callcenter',

    personal: 'personal'
};

export {roles};